/* eslint-disable
    eqeqeq,
    @typescript-eslint/no-use-before-define,
    @trello/disallow-filenames,
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS101: Remove unnecessary use of Array.from
 * DS102: Remove unnecessary code created because of implicit returns
 * DS202: Simplify dynamic range loops
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
import { Util } from 'app/scripts/lib/util';

const defaultOptions = {
  resetAfterMouseMove: true,
  intervals: [
    {
      iterations: 6,
      // eslint-disable-next-line @trello/no-module-logic
      timeout: Util.getMs({ seconds: 10 }),
    },
    {
      iterations: 10,
      // eslint-disable-next-line @trello/no-module-logic
      timeout: Util.getMs({ minutes: 1 }),
    },
  ],
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const startDecayingInterval = function (fn: any, options: any) {
  if (options == null) {
    options = defaultOptions;
  }
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  let intervals: any = null;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  let idTimeout: any = null;
  let watchingMouse = false;

  const cancel = function () {
    clearTimeout(idTimeout);
    if (watchingMouse) {
      document.removeEventListener('mousemove', start);
      watchingMouse = false;
    }
  };

  const watchMouse = function () {
    if (options.resetAfterMouseMove && !watchingMouse) {
      document.addEventListener('mousemove', start);
      watchingMouse = true;
    }
  };

  const nextStep = function () {
    if (intervals.length) {
      const nextInterval = intervals.shift();
      idTimeout = setTimeout(function () {
        fn();
        return requestAnimationFrame(nextStep);
      }, nextInterval);
      if (nextInterval > options.intervals[0].timeout) {
        watchMouse();
      }
    } else {
      watchMouse();
    }
  };

  const start = function () {
    cancel();
    intervals = [];
    // @ts-expect-error TS(2339): Property 'iterations' does not exist on type 'unkn... Remove this comment to see the full error message
    for (const { iterations, timeout } of Array.from(options.intervals)) {
      for (
        let i = 0, end = iterations, asc = 0 <= end;
        asc ? i < end : i > end;
        asc ? i++ : i--
      ) {
        intervals.push(timeout);
      }
    }
    nextStep();
  };

  start();

  return cancel;
};

export { startDecayingInterval };
